export const ABOUT_TEXT = {
	BIO: {
		section1:
			'I am a Full Stack Software Engineer mainly experienced in JavaScript, React, Redux, Node.js, GraphQL, CSS/Sass, MongoDB, MySQL and other tools related to web development and JavaScript. In early 2021, I earned a Full Stack Development Certificate from University of Pennsylvania LPS Coding Bootcamp.',
		section2:
			'I have professional experience working on an Agile team that included developing new front-end features and UI components, as well as working on back-end REST and GraphQL API endpoints, while utilizing GitHub for pull request/review workflow and Jira to track task progress.',
		section3:
			"When I'm not coding, I spend time going for walks with my wife and our dog Frodo, checking out local breweries, or I may be playing video games like Skyrim, Legend of Zelda, or Assassin's Creed. I also love traveling, having visited Japan and Italy and hope to see more countries in the future.",
	},
	HEADING: {
		h2: "Hello! I'm Tom.",
		h3: 'Full Stack Software Engineer',
	},
	IMAGE: {
		alt: 'Picture of Tom Chestnut',
	},
};

export const GITHUB_ENDPOINT = 'https://api.github.com/users/tchestnut85';
